import labels from './labels';

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
    lineChartSettings: {
      showToolTip: true,
      y2: false,
      showLegendValues: true,
      id: 'mbc-time-series-line-chart',
      yTickSize: 64,
      legendWidth: 140,
      tooltipTimeFormatAlias: 'yyyy-mm-dd',
      legendValuesFormatAlias: 'number',
      xTickFormatAlias: 'mm',
      y1TickFormatAlias: 'integer',
      dottedLines: ['Benchmark'],
    },
    emptyChartSetting: {
      id: 'mbc-time-series-line-chart empty',
      legendWidth: 140,
      timelineLevel: 'year',
      yTickSize: 64,
      xDomain: [
        new Date(new Date().getFullYear() - 10, 0, 1),
        new Date(new Date().getFullYear(), 11, 31),
      ],
      y1TickValues: [0, 5, 10],
      y1TickFormat(value) {
        return value === 0 ? value : ' \u2014';
      },
    },
  },
  components: {},
  labels: {
    en: labels['en-US'],
    ...labels,
  },
};
